module.exports = __webpack_public_path__ + "media/pharmacogenetic_animation.6851e254.webm";